export default __webpack_public_path__ + "static/video-preview-1c16a713bc5fe96b88af89f120457043.png";